export type ReasonObj = {
  bankAccountId: number;
  id: number;
  description: string;
};

export type CancelReasonModalProps = {
  isOpen: boolean;
  setClose: () => void;
  reason?: ReasonObj;
};

export const stepsReasonsId = {
  first: [
    6, 12, 13, 14, 15, 16, 17, 18, 20, 21, 22, 23, 24, 25, 26, 27, 29, 30, 31, 32, 33, 37, 38, 39, 40, 41, 42, 43, 44,
    46, 48, 49, 52, 53, 55, 56, 58, 61, 63, 64, 68, 69, 70
  ],
  second: [1, 3, 4, 5, 10, 19, 57, 34, 35, 36, 50, 54, 59, 62, 65],
  third: [2, 7, 8, 9, 28, 47, 51, 60, 67]
};
